(() => {
  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const frameSelector = [
    '.soyul-editorial-hero__media',
    '.soyul-campaign',
    '.soyul-fashion-card__media',
    'product-card .card-gallery',
    '.product-card .card-gallery',
    '.resource-card__image',
    '.product-media-gallery__media',
    '.product-media-container'
  ].join(',');

  let observer;

  const reveal = (frame) => frame.classList.add('is-soyul-visible');

  const register = (root = document) => {
    const frames = root.matches?.(frameSelector)
      ? [root]
      : Array.from(root.querySelectorAll?.(frameSelector) || []);

    frames.forEach((frame) => {
      if (frame.dataset.soyulMotionReady === 'true') return;
      if (!frame.querySelector('img, video')) return;

      frame.dataset.soyulMotionReady = 'true';
      frame.classList.add('soyul-image-motion-frame');

      if (mediaQuery.matches || !observer) {
        reveal(frame);
      } else {
        observer.observe(frame);
      }
    });
  };

  const start = () => {
    if (!mediaQuery.matches && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            reveal(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '8% 0px 8% 0px', threshold: 0.08 }
      );
    }

    register();

    const mutations = new MutationObserver((entries) => {
      entries.forEach((entry) => {
        entry.addedNodes.forEach((node) => {
          if (node instanceof HTMLElement) register(node);
        });
      });
    });

    mutations.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', (event) => register(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
